import { render, staticRenderFns } from "./RecycoGenericInputComponent.vue?vue&type=template&id=cf56066c&scoped=true&"
import script from "./RecycoGenericInputComponent.vue?vue&type=script&lang=js&"
export * from "./RecycoGenericInputComponent.vue?vue&type=script&lang=js&"
import style0 from "./RecycoGenericInputComponent.vue?vue&type=style&index=0&id=cf56066c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf56066c",
  null
  
)

export default component.exports